import { useState } from "react";

export const useToggle = (initial = false) => {
  const [state, setState] = useState(initial);
  const toggle = (override?: boolean) => setState(prev => override ?? !prev);

  return [state, toggle] as const;
};
